import { Icon, IconProps } from "../";

export const SupportedIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,1578 C94.48,1578 90,1582.48 90,1588 C90,1593.52 94.48,1598 100,1598 C105.52,1598 110,1593.52 110,1588 C110,1582.48 105.52,1578 100,1578 Z M100,1596 C95.59,1596 92,1592.41 92,1588 C92,1583.59 95.59,1580 100,1580 C104.41,1580 108,1583.59 108,1588 C108,1592.41 104.41,1596 100,1596 Z"
        transform="translate(-88 -1576)"
      />
    </Icon>
  );
};
